import { HTTP_STATUS_OK } from "../../../smartpak/httpstatus";
import { formatCartItemsForEvents } from "../../../vendor/googletagmanager/spevents/checkoutformatters";
import { spBeginCheckout } from "../../../vendor/googletagmanager/spevents/spbegincheckout";

export function isGuestFromCart({ referrer, search }) {
    const params = new URLSearchParams(search);

    if (!/\/cart/gi.test(referrer) || !params.has('create') || !params.has('nextPageUrl')) {
        return false;
    }

    return /\/checkout\/orderreview/gi.test(params.get('nextPageUrl')) && params.get('create') === 'false';
}

export async function getCartItems() {
    const response = await fetch('/api/shoppingcart/getshoppingcartmodel');
    const { Status, Content } = await response.json();

    if (Status !== HTTP_STATUS_OK) {
        return null;
    }

    return Content.CartItems;
}

export function beginGuestCheckout(cartItems) {
    spBeginCheckout({
        method: 'standard',
        items: formatCartItemsForEvents(cartItems)
    });
}


